export default "__VITE_ASSET__DbHtiD_z__"